import {FormField} from "../form-field/form-field";

export class FormFieldColorPicker extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$value = null;
    }

    getVal(){
        return this.$value.val();
    }

    setVal(val,noEvent){
        this.$value.asColorPicker("set",val);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$value = this.findMember("value");

        this.$value.on(
            "asColorPicker::change",
            ()=>{
                this.$root.trigger("formField:changeVal");
            }
        );

        this.$value.asColorPicker({"readonly":this.$root.data("edit")!=1});
    }
}

